import { useSearchParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { PageHeader, Typography } from '@app-velocity/ui';

import { RegisterForm } from '../../widgets/RegisterForm';

export const REGISTRATION_PAGE_TEST_IDS = {
  EMAIL: 'email-registration-test-id',
  PASSWORD: 'password-registration-test-id',
  EULA_PRIVACY_AGREEMENT: 'eula-privacy-agreement-test-id',
  MARKETING_AGREEMENT: 'marketing-agreement-test-id',
  SUBMIT: 'submit-registration-test-id',
};

export const RegistrationPage = () => {
  const [params] = useSearchParams();

  const invitation = params.get('invitation');
  const invitingTeam = params.get('team');

  const { t } = useI18n();

  return (
    <>
      <PageHeader>
        <PageHeader.Title>
          <Typography variant="header">
            {invitingTeam && invitation
              ? t('users:auth.sign_up_to_join', {
                  team: invitingTeam,
                  interpolation: { escapeValue: false, skipOnVariables: true },
                })
              : t('users:auth.sign_up')}
          </Typography>
        </PageHeader.Title>
      </PageHeader>
      <RegisterForm />
    </>
  );
};
